
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tires/[sizes]",
      function () {
        return require("private-next-pages/tires/[sizes].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tires/[sizes]"])
      });
    }
  